function DataRow(row) {
	return (<tr key={row.Country}>
		<td>{row.Country}</td>
		<td>{row.Continent}</td>
		<td>{row.Population}</td>
		<td>{row.PopulationGrowth}</td>
	</tr>);
}

function Table(props) {
	let countries = props.apiData.results || [];

	let tableStyle = {
		display: "inline-block",
		textAlign: "left",
	};

	function TableHeader(width, name, key) {
		if (props.ordering.key === key) {
			if (props.ordering.asc) {
				name += " ▲";
			} else {
				name += " ▼";
			}
		}

		const onClick = () => {
			if (props.ordering.key === key) {
				props.setOrdering({key, asc: !props.ordering.asc});
			} else {
				props.setOrdering({key, asc: false});
			}
		};

		return (<th width={width} style={{cursor: "pointer"}} onClick={onClick}>{name}</th>);
	}

	return (<table style={tableStyle}>
		<thead>
			<tr>
				{TableHeader(275, "Country", "Country")}
				{TableHeader(125, "Continent", "Continent")}
				{TableHeader(115, "Population", "Population")}
				{TableHeader(90, "Growth", "PopulationGrowth")}
			</tr>
		</thead>
		<tbody>
			{countries.map(DataRow)}
		</tbody>
	</table>);
}

export default Table
